module.exports = __webpack_public_path__ + "static/apple-touch-icon-152x152-8fc51bb89c430cbdefbdbb791b613a98.png";